import React, { FC, useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { CustomFieldBuilder } from "../../containers/utilities/CustomFieldBuilder";
import { useLocale } from "../../contexts/localeContext";
import { DynamicFieldDescriptor } from "../../models/DynamicFieldDescriptor";
import { getPresetInputsForBiometricSettings } from "../../services/biometricPresetService";
import ActivityFrame from "../activity-frame/activity-frame";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { getErrorMessage } from "../../services/utilities/ServiceError";
import { useDialog } from "../dialog/DialogContext";


interface CommsContentFormProps {
    presetId: string
    commsFields: any;
}

export const CommsCard: FC<CommsContentFormProps> = ({ commsFields = [], presetId }) => {
    const nameAccessor = 'name';
    const formik = useFormikContext();
    const [hasError, setHasError] = useState(false);
    const {translate} = useLocale();
    const customFieldBuilder: CustomFieldBuilder = new CustomFieldBuilder(formik, translate);
    const [supportedFields, setSupportedFields] = useState<DynamicFieldDescriptor[]>([]);
    const [busy, setBusy] = useState(false);
    const dialog = useDialog();

    useEffect(() => {
        formik.validateForm();
    }, [(formik.values as any).custom])

    useEffect(() => {
        const supportedFieldAccessors = supportedFields?.map(field => field.systemName) ?? new Array(0);

        if (formik.errors[nameAccessor]
            || (supportedFieldAccessors.length > 0 && Object.keys(formik.errors as any).length > 0)) {
            setHasError(true)
        }
        else {
            setHasError(false)
        }
    }, [formik.errors]);

    useEffect(() => {
        reloadPage();
    }, [])

    const reloadPage = async () => {
        try {
            setBusy(true);
            const settingData: any = await getPresetInputsForBiometricSettings(presetId, commsFields, translate);

            if (!!presetId) {
                const currentSupportedFields = settingData.elementFields;
                setSupportedFields(currentSupportedFields);
            }
            else {
                setSupportedFields(new Array<any>(0));
            }
        }
        catch (error) {
            dialog.pushError({
                title: translate.byKey(TranslationKeys.error),
                message: getErrorMessage(error),
            });
        }
        finally {
            setBusy(false);
        }
    }

    const createFields = () => {
        var arrayFields = [] as any[];
        supportedFields?.filter(field => {
            if (commsFields.includes(field.systemName)) {
                arrayFields.push(field);
            }
        });

        arrayFields.sort((a, b) => a.settingTypeOrdinal - b.settingTypeOrdinal);

        return arrayFields?.reduce((formFields, field) =>
           customFieldBuilder.buildFormField(formFields, field, false, true, undefined, true),
            new Array(0))
            .map(fieldBundle => <div className="flex flex-row pt-3">{fieldBundle.length === 1
                ? fieldBundle[0].span
                    ? fieldBundle[0].content
                    : <>{fieldBundle[0].content}
                        <div className="flex flex-col flex-1 pl-3"></div></>
                : fieldBundle.map(field => field.content)}</div>)
    }

    return <ActivityFrame busy={busy} className={`${busy ? 'mt-5 w-full h-full' : ''} flex flex-col flex-grow bg-white`}>
        {createFields()}
    </ActivityFrame>;
}

export default CommsCard;
